// Translations

var i18nLocales = {
  // The language in native form
  language: {
    en: 'English',
    de: 'Deutsch'
  },

  // Global
  error: {
    en: 'An unknown error occurred',
    de: 'Unbekannter Fehler aufgetreten'
  },
  saveButton: {
    en: 'Save',
    de: 'Speichern'
  },
  deleteButton: {
    en: 'Delete',
    de: 'Löschen'
  },
  timeAt: {
    en: 'at',
    de: 'um'
  },
  dateCreatedOn: {
    en: 'At',
    de: 'Am'
  },
  createdBy: {
    en: 'by',
    de: 'von'
  },

  // Sign in page
  signInButton: {
    en: 'Sign In',
    de: 'Einloggen'
  },
  createdByCredits: {
    en: 'Created by <a href="https://www.bup-ing.de/" target="_blank">BuP. Boll Beraten und Planen</a>',
    de: 'Ein Produkt von <a href="https://www.bup-ing.de/" target="_blank">BuP. Boll Beraten und Planen</a>'
  },
  publicLoginPlaceholderUsername: {
    en: 'Username',
    de: 'Benutzername'
  },
  publicLoginPlaceholderPassword: {
    en: 'Password',
    de: 'Passwort'
  },

  // Menu
  menuIsolateSelection: {
    en: 'Isolate selection',
    de: 'Auswahl isolieren'
  },
  menuZoomToSelection: {
    en: 'Zoom to selection',
    de: 'Zur Auswahl zoomen'
  },
  menuOpenPublicLink: {
    en: 'Open public link',
    de: 'Öffenlichen Link öffnen'
  },
  menuProjectDetails: {
    en: 'Project details',
    de: 'Projekt Informationen'
  },
  menuAddToBookmarks: {
    en: 'Add to bookmarks',
    de: 'Lesezeichen hinzufügen'
  },
  menuRemoveBookmark: {
    en: 'Remove bookmark',
    de: 'Lesezeichen entfernen'
  },
  menuSignOut: {
    en: 'Sign out',
    de: 'Ausloggen'
  },

  // Project details
  projectDetailsTitle: {
    en: 'Project details',
    de: 'Projekt Informationen'
  },
  projectDetailsProjectIDAPI: {
    en: 'Project ID (API)',
    de: 'Projekt ID (API)'
  },
  projectDetailsProjectIDAutodesk: {
    en: 'Project ID (Autodesk)',
    de: 'Projekt ID (Autodesk)'
  },
  projectDetailsNodeID: {
    en: 'Node ID (urn)',
    de: 'Node ID (urn)'
  },

  // Project list
  projectListTitleBookmarks: {
    en: 'Bookmarks',
    de: 'Lesezeichen'
  },
  projectListTitleProjects: {
    en: 'Projects',
    de: 'Projekte'
  },
  treeLoadingText: {
    en: 'Loading...',
    de: 'Lade...'
  },

  // Panel
  loadingPanel: {
    en: 'Loading panel...',
    de: 'Lade Menü...'
  },
  panelTitleNodes: {
    en: 'Nodes',
    de: 'Nodes'
  },
  panelTitleCharts: {
    en: 'Charts',
    de: 'Diagramme'
  },
  panelTitleProperties: {
    en: 'Properties',
    de: 'Eigenschaften didi'
  },
  panelTitleIssues: {
    en: 'Issues',
    de: 'Issues'
  },
  panelTitleProtocols: {
    en: 'Protocols',
    de: 'Protokolle'
  },
  panelChartsSelectPlaceholder: {
    en: 'Select category...',
    de: 'Kategorie wählen...'
  },
  panelNoticeSelectNode: {
    en: 'Select a node<br>to show properties.',
    de: 'Node wählen<br>um Eigenschaften anzuzeigen.'
  },
  panelNoticeNoInspections: {
    en: 'No protocols...',
    de: 'Keine Protokolle...'
  },
  panelNoticeLoadingProtocols: {
    en: 'Loading protocols...',
    de: 'Lade Protokolle...'
  },
  panelNoticeNoProtocols: {
    en: 'There are<br>no active protocols.',
    de: 'Keine aktiven<br>Protokolle vorhanden.'
  },
  panelNoticeCouldNotLoadProtocols: {
    en: 'Could not load protocols.',
    de: 'Protokolle konnten<br>nicht geladen werden.'
  },
  panelNoticeLoadingIssues: {
    en: 'Loading issues...',
    de: 'Lade Issues...'
  },

  // Calendar panel
  panelCalendarTitle: {
    en: 'Calendar',
    de: 'Kalender'
  },
  panelCalendarNoTasksMessage: {
    en: 'There are no tasks<br>within the current selection.',
    de: 'In diesem Zeitraum<br>sind keine Aufgaben vorhanden'
  },
  panelCalendarTreeHeadingStartShouldIs: {
    en: 'Start should<br>Start is',
    de: 'Start Soll<br>Start Ist'
  },
  panelCalendarTreeHeadingEndShouldIs: {
    en: 'End should<br>End is',
    de: 'Ende Soll<br>Ende Ist'
  },
  panelCalendarTreeHeadingDurationShouldIs: {
    en: 'Dur.',
    de: 'Dauer'
  },
  panelCalendarTreeHeadingAmount: {
    en: 'Amount',
    de: 'Anzahl'
  },
  panelCalendarTreeHeadingStatus: {
    en: 'Status',
    de: 'Status'
  },

  // Protocol
  protocolModalNavButtonInspection: {
    en: 'Protocol data ',
    de: 'Protokoll-Daten'
  },
  protocolModalNavButtonIssues: {
    en: 'Issues',
    de: 'Issues'
  },

  // Inspections
  inspectionNoticeLoadingInspection: {
    en: 'Loading protocol...',
    de: 'Lade Protokoll...'
  },
  inspectionNoticeCouldNotLoadInspection: {
    en: 'Could not load protocol.',
    de: 'Protokoll konnte nicht geladen werden.'
  },
  inspectionMainValueObject: {
    en: 'Monitored components',
    de: 'Überwachte Bauteile'
  },
  inspectionMainValueTypeAcceptanceReportConstructionWork: {
    en: 'Construction Work',
    de: 'Baumassnahme'
  },
  inspectionMainValueTypeAcceptanceReportStructure: {
    en: 'Structure',
    de: 'Bauwerk'
  },
  inspectionMainValueTypeAcceptanceReportStructureNumber: {
    en: 'Structure Number',
    de: 'Bauwerksnummer'
  },
  inspectionMainValueDocuments: {
    en: 'Planning documents',
    de: 'Plandokumente'
  },
  inspectionMainValueInspector: {
    en: 'Involved people',
    de: 'Beteiligte Personen'
  },
  inspectionMainValueInspectorPlaceholderLabel: {
    en: 'Position',
    de: 'Position'
  },
  inspectionMainValueInspectorPlaceholderName: {
    en: 'Name',
    de: 'Name'
  },
  inspectionMainValueDateOfInspection: {
    en: 'Date',
    de: 'Datum'
  },
  inspectionMainValueTimeOfInspection: {
    en: 'Time',
    de: 'Uhrzeit'
  },
  inspectionMainValueWeather: {
    en: 'Weather',
    de: 'Witterung'
  },
  inspectionMainValueTemperature: {
    en: 'Temperature',
    de: 'Temperatur'
  },
  inspectionMainValueDescription: {
    en: 'More infos',
    de: 'Weitere Information'
  },
  inspectionSaveSuccessNotice: {
    en: 'Protocol saved',
    de: 'Protokoll gespeichert'
  },
  inspectionAddMoreInspectorsButton: {
    en: 'Add another person',
    de: 'Weitere Person hinzufügen'
  },

  // Issue
  issueAddIssue: {
    en: 'Add Issue',
    de: 'Issue hinzufügen'
  },
  issueCreateIssue: {
    en: 'Create Issue',
    de: 'Issue erstellen'
  },
  issueEditIssue: {
    en: 'Edit Issue',
    de: 'Issue bearbeiten'
  },
  issueNoticeSelectACategory: {
    en: 'Select a category...',
    de: 'Kategorie wählen...'
  },
  issueInputCategoryPlaceholder: {
    en: 'Select category',
    de: 'Kategorie wählen'
  },
  issueInputTitlePlaceholder: {
    en: 'Title',
    de: 'Titel'
  },
  issueInputTypeAcceptanceReportTitlePlaceholder: {
    en: 'Component',
    de: 'Bauteil'
  },
  issueInputDescriptionPlaceholder: {
    en: 'Description',
    de: 'Beschreibung'
  },
  issueNoticeNoDescription: {
    en: 'No description...',
    de: 'Keine Beschreibung...'
  },
  issueSaveSuccessNotice: {
    en: 'Issue saved',
    de: 'Issue gespeichert'
  },
  issueSaveSuccessNoticeCreated: {
    en: 'Issue created',
    de: 'Issue erstellt'
  },
  issueSaveSuccessNoticeEdited: {
    en: 'Issue edited',
    de: 'Änderungen gespeichert'
  },
  issueNoticeNoIssuesInCategory: {
    en: 'No issues in this category...',
    de: 'Keine Issues in dieser Kategorie...'
  },

  // Push Pin
  pushPinNoticeSelectNode: {
    en: 'Select the node for the PushPin.',
    de: 'Welche Node wird mit diesem PushPin verknüpft?'
  },
  pushPinNoticeAddPushPin: {
    en: 'Add PushPin',
    de: 'PushPin hinzufügen'
  },
  pushPinNoticeChangePushPinLocation: {
    en: 'Change PushPin',
    de: 'PushPin ändern'
  },

  // Components
  componentsNoticeSelectComponents: {
    en: 'Select the components for this issue.',
    de: 'Wählen sie die Bauteile für dieses Issue.'
  },
  componentsNoticeComponentsSelected: {
    en: 'Select Components',
    de: 'Bauteile wählen'
  },
  selectComponentsButton: {
    en: 'Select Components',
    de: 'Bauteile wählen'
  },
  changeComponentsButton: {
    en: '{n} Components',
    de: '{n} Bauteile'
  },

  // Attachments
  attachmentsTitle: {
    en: 'Attachments',
    de: 'Anhänge'
  },
  attachmentsFileButtonPlaceholder: {
    en: 'Attach files',
    de: 'Anhänge hinzufügen'
  },
  attachScreenshotButton: {
    en: 'Add screenshot',
    de: 'Screenshot hinzufügen'
  },
  takeScreenshotButton: {
    en: 'Take screenshot',
    de: 'Screenshot erstellen'
  },
  attachmentsNotice1File: {
    en: '1 file',
    de: '1 Datei'
  },
  attachmentsNoticeNFiles: {
    en: '{0} files',
    de: '{0} Dateien'
  },
  attachmentsNoticeNoAttachments: {
    en: 'No attachments...',
    de: 'Keine Anhänge...'
  },
  attachmentsNoticeLoadingAttachments: {
    en: 'Loading attachments...',
    de: 'Lade Anhänge...'
  },
  attachmentsNoticeAttachmentsCouldNotBeLoaded: {
    en: 'Attachments could not be loaded...',
    de: 'Anhänge konnten nicht geladen werden...'
  },

  // Comments
  commentsSectionTitle: {
    en: 'Comments',
    de: 'Kommentare'
  },
  commentsSectionWriteAComment: {
    en: 'Write a comment...',
    de: 'Kommentar schreiben...'
  },
  commentsSectionBeTheFirstToWriteAComment: {
    en: 'Be the first to write a comment...',
    de: 'Schreibe ein Kommentar...'
  },
  commentsSaveSuccessNotice: {
    en: 'Comment added',
    de: 'Kommentar hinzugefügt'
  },

  // Signature pad
  signaturePadSaveButton: {
    en: 'Add signature',
    de: 'Unterschrift hinzufügen'
  }
};

// Translate strings

function __(id, rep, lang) {
  if (!i18nLocales[id]) {
    return '';
  }

  var str = i18nLocales[id][lang] || i18nLocales[id][settings.language];
  rep &&
    rep.forEach(function (replace, index) {
      str = str.replace('{' + index + '}', replace);
    });
  return str;
}

// Initialize language

function initLanguage(language) {
  var elements = document.querySelectorAll('[data-translate]');
  elements &&
    elements.forEach(function (el) {
      // Language id
      var value = el.getAttribute('data-translate');

      // Replacement
      var rep = el.getAttribute('data-translate-rep');
      rep = rep ? rep.split('|') : null;

      // Attribute
      var attr = el.getAttribute('data-translate-attr');

      // Replace attribute
      if (attr) {
        el.setAttribute(attr, __(value, rep, language));
        return;
      }

      // Relace HTML
      el.innerHTML = __(value, rep, language);
    });
}

$(function () {
  initLanguage(settings.language);
});
